<template>
<div class="chapter">
<div class="inner_page">
<p class="epigraph" title="Epigraph"><i>“Now cracks a noble heart. Good night, sweet prince, and flights of angels sing thee to thy rest</i>.”<br/><span class="small">WILLIAM SHAKESPEARE</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Epigraph.vue?18f95c58